import { render, staticRenderFns } from "./institutionList.vue?vue&type=template&id=5e53c924&scoped=true"
import script from "./institutionList.vue?vue&type=script&lang=js"
export * from "./institutionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53c924",
  null
  
)

export default component.exports